function initMulticolumSlider(root) {
    var grid = root.querySelector('.multicolum-steps__grid');
    var dots = root.querySelector('.multicolum-steps__dots');
    if (!grid || !dots || grid.dataset.sliderReady === 'true') return;

    var cards = grid.querySelectorAll('.multicolum-steps__card');
    var buttons = dots.querySelectorAll('.multicolum-steps__dot-btn');
    var mobile = window.matchMedia('(max-width: 749px)');

    function setActive(index) {
      buttons.forEach(function (button, buttonIndex) {
        var isActive = buttonIndex === index;
        button.classList.toggle('is-active', isActive);
        if (isActive) {
          button.setAttribute('aria-current', 'true');
        } else {
          button.removeAttribute('aria-current');
        }
      });
    }

    grid.addEventListener('scroll', function () {
      if (!mobile.matches) return;
      var closest = 0;
      var min = Infinity;
      cards.forEach(function (card, index) {
        var distance = Math.abs(card.offsetLeft - grid.scrollLeft);
        if (distance < min) {
          min = distance;
          closest = index;
        }
      });
      setActive(closest);
    }, { passive: true });

    buttons.forEach(function (button, index) {
      button.addEventListener('click', function () {
        var card = cards[index];
        if (!card) return;
        grid.scrollTo({ left: card.offsetLeft, behavior: 'smooth' });
        startAutoplay();
      });
    });

    var delay = parseInt(root.dataset.sliderDelay, 10);
    if (!delay || delay < 1) delay = 5000;
    var timer = null;

    function stopAutoplay() {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    }

    function startAutoplay() {
      stopAutoplay();
      if (!mobile.matches || cards.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = window.setInterval(function () {
        if (!mobile.matches) return;
        var current = 0;
        buttons.forEach(function (button, index) {
          if (button.classList.contains('is-active')) current = index;
        });
        var next = (current + 1) % cards.length;
        var card = cards[next];
        if (!card) return;
        grid.scrollTo({ left: card.offsetLeft, behavior: 'smooth' });
      }, delay);
    }

    grid.addEventListener('pointerdown', stopAutoplay);
    grid.addEventListener('pointerup', startAutoplay);
    mobile.addEventListener('change', startAutoplay);
    startAutoplay();

    grid.dataset.sliderReady = 'true';
  }

  function initMulticolumSteps(root) {
    if (!root) return;
    initMulticolumSlider(root);
    if (root.dataset.multicolumStepsReady === 'true') return;
    if (window.matchMedia('(max-width: 749px)').matches) {
      root.querySelectorAll('.multicolum-steps__card').forEach(function (card) {
        card.classList.add('is-visible');
      });
    }
    if (root.dataset.reveal !== 'true') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      root.querySelectorAll('.multicolum-steps__card').forEach(function (card) {
        card.classList.add('is-visible');
      });
      root.dataset.multicolumStepsReady = 'true';
      return;
    }

    var cards = root.querySelectorAll('.multicolum-steps__card');
    if (!('IntersectionObserver' in window)) {
      cards.forEach(function (card) {
        card.classList.add('is-visible');
      });
      root.dataset.multicolumStepsReady = 'true';
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.2 }
    );

    cards.forEach(function (card, index) {
      card.style.transitionDelay = index * 80 + 'ms';
      observer.observe(card);
    });
    root.dataset.multicolumStepsReady = 'true';
  }

  function bootMulticolumSteps(scope) {
    var context = scope || document;
    context.querySelectorAll('[data-multicolum-steps]').forEach(initMulticolumSteps);
  }

  bootMulticolumSteps(document);
  document.addEventListener('shopify:section:load', function (event) {
    bootMulticolumSteps(event.target);
  });
